module.exports = __webpack_public_path__ + "39f4e375a19061f3dc060aae8c950800.svg";